import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

export interface ITableColumns {
	name: string;
	component?: 'userBadge' | 'iconTitle' | 'default';
}

@Component({
	selector: 'app-table-skeleton',
	imports: [CommonModule],
	templateUrl: './table-skeleton.component.html',
	styleUrl: './table-skeleton.component.scss',
})
export class TableSkeletonComponent {
	columns = input.required<ITableColumns[]>();
}
